<template>
  <main>
    <div class="section">
      <div class="container">
        <div class="columns is-multiline">
          <div class="column is-full">
            <DashboardNavigation />
          </div>
          <div class="column is-full">
            <template>
              <vue-page-transition name="fade">
                <router-view name="dashboardOptions" v-if="isLoaded"></router-view>
              </vue-page-transition>
              <vue-page-transition name="fade">
                <router-view name="dashboard" v-if="isLoaded"></router-view>
              </vue-page-transition>
              <b-loading :is-full-page="false" :active="!isLoaded" />
            </template>
            <DashboardFeed :feed="feed" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import api from '@/api/api';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'Dashboard',
  components: {
    DashboardNavigation: () =>
      import(/* webpackChunkName: "DashboardNavigation" */ '@/components/dashboards/DashboardNavigation.vue'),
    DashboardFeed: () => import(/* webpackChunkName: "DashboardFeed" */ '@/components/dashboards/DashboardFeed.vue')
  },
  data() {
    return {
      isLoading: true,
      // Feed
      feed: [],
      query: {
        start: 0,
        end: 10,
        sort: 'date',
        order: 'desc'
        // invert_is_table_key: false
      }
    };
  },
  methods: {
    ...mapActions('dashboard', {
      loadDashboards: 'loadDashboards',
      loadDashboard: 'loadDashboard',
      loadExtended: 'loadExtended'
    })
  },
  computed: {
    ...mapState({
      dashboards: state => state.dashboard.dashboards,
      dashboard: state => state.dashboard.dashboard
    }),
    ...mapGetters('dashboard', {
      extended: 'extended'
    }),
    isLoaded() {
      return this.dashboard && this.extended;
    }
  },
  mounted() {
    const findExtendedIndex = () => {
      if (this.$route.params.extendedId) {
        return {
          id: this.dashboard.id,
          extendedId: this.$route.params.extendedId
        };
      }

      const extended = this.dashboard.extended.values.find(el => el.default === true);

      return {
        id: this.dashboard.id,
        extendedId: extended.id
      };
    };

    const findDashboardIndex = () => {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }

      const activeDashboardId = this.dashboards.find(dashboard => dashboard.active === true);

      return activeDashboardId.id;
    };

    api.getTables(this.query).then(response => {
      this.feed = Object.values(response.data);
    });

    this.loadDashboards().then(async () => {
      await this.loadDashboard(findDashboardIndex());
      await this.loadExtended(findExtendedIndex());
    });
  }
};
</script>

<style lang="scss" scoped>
.notification {
  padding-right: 1.5rem;
  line-height: 1.2;
}

.column {
  position: relative;
}

.sticky {
  position: sticky;
  top: 0;
}
</style>
